import { css } from 'emotion'
// import { FONT_WEIGHT_BOLD } from 'constants/styleConstants'
// import { BORDER_RADIUS, NEUTRAL_BORDER_COLOR } from 'constants/styleConstants'

export const TeamNameLinkStyles = css``
